import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, unref as _unref, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vShow as _vShow, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-887ff622"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"height":"100%"} }
const _hoisted_2 = {
  class: "regional",
  style: {"height":"100%"}
}
const _hoisted_3 = { style: {"position":"relative","display":"flex"} }
const _hoisted_4 = {
  class: "from",
  style: {"width":"50%"}
}
const _hoisted_5 = {
  class: "from",
  style: {"margin-left":"40px","width":"50%"}
}
const _hoisted_6 = {
  class: "btnBox",
  style: {"display":"block","padding":"0","width":"75px","margin-left":"40px"}
}
const _hoisted_7 = { style: {"display":"flex"} }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "page" }
const _hoisted_10 = { style: {"color":"#5E6A71","font-size":"14px"} }
const _hoisted_11 = { style: {"height":"100%","box-sizing":"border-box","position":"relative"} }
const _hoisted_12 = { class: "userFrom" }
const _hoisted_13 = { class: "from disFrom" }
const _hoisted_14 = { class: "from disFrom" }
const _hoisted_15 = { class: "systemListBox" }
const _hoisted_16 = { class: "listBox" }
const _hoisted_17 = { class: "btnBox" }
const _hoisted_18 = {
  key: 1,
  class: "btn line pointer"
}

import type { PropType } from 'vue'
import { ref,reactive,computed, watch } from 'vue'
import { getRolePlanList,getPlanList,updateRolePlan } from '../loginApi'
import { SystemType } from '../types'
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  __name: 'Permission',
  props: {
  systemList: {
    type: Array as PropType<SystemType[]>,
    required: true, // 必须传递
  },
},
  emits: ['setLine', 'delLine'],
  setup(__props, { emit: emits }) {

const props = __props;


// import dayjs from 'dayjs'
const { t } = useI18n();

const store = useStore();
const getLanguageValue = computed(() => store.getters.getLanguageValue);

function init() {
  getList()
  getPlanListFn()
}
const addShow = ref(false)
watch(
  addShow,
  (newData) => {
      if (newData) {
        emits('setLine', 'add', [{ name: t('login.ConfigurationServicePlan'),callback: function(){addShow.value = false} }])
      } else {
        emits('delLine', 1)
      }
    },
    { immediate: true }
  );
const btnLoading = ref(false)
// 获取表格数据
const page = reactive({
  pageNo: 1,
  pageSize: 10,
  total: 0
})
const tableData = ref([
  // {
  //   date: '2016-05-03',
  //   name: 'Tom',
  //   address: 'No. 189, Grove St, Los Angeles',
  // },
])
const search = reactive({
  planCode: '',
  systemId: ''
})
let loading = ref(false)
// 获取表格数据
function getList() {
  loading.value = true
  getRolePlanList({...page,...search}).then(res => {
    tableData.value = res.data.records
    page.total = res.data.total
  }).finally(()=>loading.value = false)
}
// 获取配置下拉框
const roleList = ref<{planName:string,id:string}[]>([
])
function getPlanListFn() {
  getPlanList().then(res => {
    roleList.value = res.data 
  })
}

function handleSizeChange(val: number) { 
  page.pageNo = 1
  page.pageSize = val
  getList()
}
function handleCurrentChange(val:number) {
  page.pageNo = val
  getList()
}

// 表格/删除新增列
function changeSystem(item: any) {
  console.log(item)
}
function handleSet(item:any) {
  addShow.value = true
  form.roleName = item.roleName
  form.roleId = item.roleId
  form.systemName = item.systemName
  form.planName = item.planName.split(',')
}
// 新增/修改用户
const form = reactive({
  roleName: '',
  systemName: '',
  roleId: '',
  planName: []
})

// 提交验证
function handleSumbit() {
  const obj = {
    roleId: form.roleId,
    planName: form.planName.join(',')
  }
  console.log(obj)
  updateRolePlan(obj).then(res => {
    addShow.value = false
    getList()
  })
}


init()

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_select, {
            modelValue: search.systemId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search.systemId) = $event)),
            class: "w-50 m-2 inputbox",
            size: "large",
            placeholder: _ctx.$t('login.allSubsystem'),
            type: "text",
            clearable: "",
            style: {"height":"48px"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.systemList, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.systemName,
                  value: item.id
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_input, {
            modelValue: search.planCode,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search.planCode) = $event)),
            class: "w-50 m-2 inputbox",
            size: "large",
            placeholder: _ctx.$t('login.input')+_ctx.$t('login.servicePlanLabel'),
            type: "text",
            onKeydown: _withKeys(getList, ["enter"]),
            style: {"height":"48px"}
          }, null, 8, ["modelValue", "placeholder", "onKeydown"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: "btn line pointer",
            onClick: getList
          }, _toDisplayString(_ctx.$t('login.inquire')), 1)
        ])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        style: {"width":"100%"},
        size: "large",
        height: "100%",
        "max-height": "calc(100% - 110px)",
        ref: "tableRef"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "systemName",
            label: _ctx.$t('login.subsystem')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "roleName",
            label: _ctx.$t('login.user')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "planName",
            label: _ctx.$t('login.servicePlanLabel'),
            width: "350",
            "show-overflow-tooltip": ""
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "date",
            label: _ctx.$t('login.operating'),
            width: '160'
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", {
                  class: "operatingBtn pointer",
                  style: {"color":"#F6760F"},
                  onClick: ($event: any) => (handleSet(scope.row))
                }, _toDisplayString(_ctx.$t('login.ConfigurationServicePlan')), 9, _hoisted_8)
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, _unref(loading)]
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('login.total',{total:page.total})), 1),
        _createVNode(_component_el_pagination, {
          "current-page": page.pageNo,
          "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((page.pageNo) = $event)),
          "page-size": page.pageSize,
          "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((page.pageSize) = $event)),
          "page-sizes": [100, 200, 300, 400],
          layout: "prev, pager, next, jumper",
          total: page.total,
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange,
          background: true
        }, null, 8, ["current-page", "page-size", "total"])
      ])
    ], 512), [
      [_vShow, !addShow.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", {
              style: _normalizeStyle({width:getLanguageValue.value==='en'?'160px':'110px'})
            }, _toDisplayString(_ctx.$t('login.subsystem')), 5),
            _createVNode(_component_el_input, {
              modelValue: form.systemName,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.systemName) = $event)),
              class: "w-50 m-2 inputbox",
              size: "large",
              type: "text",
              disabled: ""
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", {
              style: _normalizeStyle({width:getLanguageValue.value==='en'?'160px':'110px'})
            }, _toDisplayString(_ctx.$t('login.user')), 5),
            _createVNode(_component_el_input, {
              modelValue: form.roleName,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.roleName) = $event)),
              class: "w-50 m-2 inputbox",
              size: "large",
              type: "text",
              disabled: ""
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t('login.ConfigurationServicePlan')), 1),
            _createElementVNode("div", null, [
              _createVNode(_component_el_select, {
                modelValue: form.planName,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.planName) = $event)),
                class: "m-2 inputBox",
                placeholder: _ctx.$t('login.select')+_unref(t)('login.ConfigurationServicePlan'),
                size: "large",
                style: {"width":"100%"},
                onChange: changeSystem,
                multiple: "",
                filterable: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleList.value, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.planName,
                      value: item.planName
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        (!btnLoading.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "btn line pointer",
              onClick: handleSumbit
            }, _toDisplayString(_ctx.$t('login.save')), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createTextVNode(_toDisplayString(_ctx.$t('login.save')) + " ", 1),
              _createVNode(_component_el_icon, {
                class: "el-icon is-loading",
                style: {"margin-left":"5px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Loading)
                ]),
                _: 1
              })
            ])),
        _createElementVNode("div", {
          class: "btn pointer",
          onClick: _cache[7] || (_cache[7] = ($event: any) => {addShow.value = false;emits('delLine', 1)})
        }, _toDisplayString(_ctx.$t('login.cancel')), 1)
      ])
    ], 512), [
      [_vShow, addShow.value]
    ])
  ]))
}
}

})